
    import "src/app/AppSeller/SettingsPage/Integrations/ThirdPartyLogisticPreferences/index.module.scss?farm_css_modules";
    
    export default {"preferenceCardList": `preferenceCardList-a9e8b932`,"thirdPartyLogisticContainer": `thirdPartyLogisticContainer-a9e8b932`}
    